import { createHeaders, useServerState } from "@project-mgmt/api-client";
export function useDashboardMetrics(workspaceId) {
    const queryParams = new URLSearchParams();
    if (workspaceId) {
        queryParams.set("workspaceId", workspaceId);
    }
    return useServerState({
        key: ["dashboard", "metrics", workspaceId],
        fetcher: async (_, signal) => {
            const response = await fetch(`/api/dashboard/metrics?${queryParams.toString()}`, {
                signal,
                headers: createHeaders(workspaceId),
            });
            if (!response.ok) {
                throw new Error(`Failed to fetch dashboard metrics: ${response.statusText}`);
            }
            return response.json();
        },
        onError: (error) => {
            console.error("Dashboard metrics error:", error);
        },
    });
}
